import React,{useState} from 'react'

function VoiceSequence({voiceSequence,handleUpdate,handleDelete,vsid}) {
  
    const [vs,setVs] = useState(voiceSequence)
    const deleteVs = ()=>{
        handleDelete(vsid)
    }
  return (
    <>
     <div className="row mb-2">
        
            <div className="col-lg-2 col-md-2">
                <select name="" id="" className='form-select' value={voiceSequence.type}
                    onChange = {(e)=>{
                        const updatedItem = {...voiceSequence,type:e.target.value};
                        handleUpdate(vsid,updatedItem)
                    }}
                >
                    <option value="STATIC">Static</option>
                    <option value="DYNAMIC">Dyanmic</option>
                </select>
            </div>
            <div className="col-lg-5 col-md-5">
               <input type="text" className="form-control" value={voiceSequence.content}
                onChange={(e)=>{
                    const updatedItem = {...voiceSequence,content:e.target.value}
                    handleUpdate(vsid,updatedItem)
                }}
               />
            </div>
            <div className="col-lg-3 col-md-3">
               <input type="text" className="form-control" value={voiceSequence.path}
                onChange={(e)=>{
                    const updatedItem = {...voiceSequence,content:e.target.value}
                    handleUpdate(vsid,updatedItem)
                }}
               />
            </div>
            <div className="col-lg-2 col-md-2">
                   
                <button className="btn btn-warning btn-sm" onClick={deleteVs} >
                    <i className="bi bi-trash3-fill"></i>
                </button>
            </div>
       
     </div>
    </>
  )
}

export default VoiceSequence